export default function restart() {
  // unmounting the app will now be handled by using an
  // event listener in 'src/index.tsx'
  window.location.reload();
}

